/* 61454143: pure view-model helpers for the slicing plate picker and the
   bundled-baseline fallback copy. No React imports so tests stay light. */

import type { OrderModelFile, SlicingPrinter } from '../types/slicing';

/** Plate choices for a model file: [] when a picker adds nothing. */
export function plateOptions(file?: OrderModelFile | null): number[] {
  const count = file?.plateCount ?? 0;
  if (!Number.isFinite(count) || count <= 1) return [];
  return Array.from({ length: count }, (_, i) => i + 1);
}

/** Backend contract: 0 = all plates, N = plate N (1-indexed). */
export function plateLabel(plateIndex?: number | null): string {
  return plateIndex && plateIndex > 0 ? `Пластина ${plateIndex}` : 'Все пластины';
}

/** STL/OBJ/STEP need full profiles: own presets or a bundled BBL baseline. */
export function printerCanSliceModels(printer?: SlicingPrinter | null): boolean {
  if (!printer) return false;
  return printer.hasProfiles || !!printer.bundledProfileFamily;
}

/** Caption shown under the picker; null = nothing to explain. */
export function printerProfileHint(printer?: SlicingPrinter | null): string | null {
  if (!printer || printer.hasProfiles) return null;
  if (printer.bundledProfileFamily) {
    return `У принтера нет своих профилей — используются базовые профили Bambu Lab (${printer.bundledProfileFamily}).`;
  }
  return 'У принтера нет профилей слайсера — добавьте пресеты machine/process/filament на карточке принтера в разделе «Принтеры».';
}
